import { LOGGED_IN_DATA, AUTH_DATA ,APPOINTMENT_AUTH_DATA} from "../constants/index";

export const getWhoAmIToken = () => {
	const authStr = localStorage.getItem("WOH_AM_I_DATA");
	if (authStr) {
	  const authJSON = JSON.parse(authStr);
	  return authJSON?.data;
	}
	return null;
  };

export const getAuthData = () => {
	const authStr = localStorage.getItem(AUTH_DATA);
	if (authStr) {
		const authJSON = JSON.parse(authStr);
		return authJSON;
	}
	return null;
};
export const getAuthTokenDMS = () => {
	const authStr = localStorage.getItem(APPOINTMENT_AUTH_DATA);
	if (authStr) {
		const authJSON = JSON.parse(authStr);
		return authJSON.AuthenticationToken ;
	}
	return null;
};
export const getUserAuthTokenDMS = () => {
	const authStr = localStorage.getItem(LOGGED_IN_DATA);
	if (authStr) {
		const authJSON = JSON.parse(authStr);
		return authJSON?.AuthenticationToken || null;
	}
	return null;
};
export const getAuthToken = () => {
	const authStr = localStorage.getItem(AUTH_DATA);
	if (authStr) {
		const authJSON = JSON.parse(authStr);

		return authJSON.Token || null;
	}
	return null;
};

export const getUserAuthToken = () => {
	const authStr = localStorage.getItem(LOGGED_IN_DATA);
	if (authStr) {
		const authJSON = JSON.parse(authStr);
		return authJSON?.Token || null;
	}
	return null;
};



export const setLocalData = (key: string, data: any) => {
	if (key && data) localStorage.setItem(key, JSON.stringify(data));
};

export const getSchemaIdFromMetaData = (metaData: Array<any>, systemName: string) => {
	const result = metaData?.find((item: any) => item.SystemName === systemName);
	return result ? result.SchemaId : null;
};

export const checkDuplicateField = (array: Array<any> = [], data: any, field: string) => {
	const isDuplicate = array.some(
		(item: any) =>
			item[field]?.toLowerCase() === data[field]?.toLowerCase() &&
			item?.id !== data?.id
	);
	return isDuplicate
}